import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const getActivityAuditList = (
  activityAuditObject: any
): Promise<AxiosResponse> => {
  let businessUnit =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id;
  let config: AxiosRequestConfig = {
    params: {
      businessUnit: businessUnit,
    },
  };
  config.params.page = (activityAuditObject.controller.page || 0) + 1;
  config.params.limit = activityAuditObject.controller.limit;
  config.params.searchText = activityAuditObject.searchText;
  config.params.recordCode = activityAuditObject.recordCode;
  return axiosAuth.get(API_PATH().apis.activityaudit, config);
};
